export default {
  review: {
    title: 'Bewertungen',
    reviewAmountLabel: '{n} Bewertung | {n} Bewertungen',
    seeAll: 'Alle Bewertungen lesen',
    verifiedLabel: 'Verifizierter Kauf',
    heading: {
      title: 'Wir freuen uns über Deine Bewertung.',
      description:
        'Dein Feedback hilft dem Kursleiter sehr. Auf gokonfetti.com wird nur Dein Vorname veröffentlicht.',
    },
    rating: {
      title: 'Gibst Du dem Kurs 5 Sterne?',
    },
    review: {
      title: 'Schreibe ein paar Sätze über den Kurs.',
      placeholder:
        'z.B.: Für wen würdest Du den Kurs empfehlen? Was hat Dir am besten gefallen?',
    },
    loginPage: {
      title: 'Dein Feedback hilft uns, uns zu verbessern',
      partnerSubtitle: 'Bewerte den Kurs, den du gerade besucht hast',
      partnerPrefix: 'von',
      loginFormTitle: 'Einfach anmelden um zu bewerten',
    },
    legalCopy:
      'Mit dem Absenden Deiner Bewertung erklärst Du Dich mit unseren {termsAndConditions} einverstanden.',
    termsAndConditions: 'AGB',
    notification: {
      success: {
        title: 'Vielen Dank für Deine Bewertung',
        description:
          'Als kleines Dankeschön für Dein Feedback erhältst du 15 € Rabatt mit dem Code KONBACK10. Mindestbestellwert 50 €.',
      },
      error: {
        title: 'Es ist ein Fehler aufgetreten',
        description:
          'Wenn Du diesen Kurs bereits bewertet hast, kannst Du diesen nicht erneut bewerten.',
      },
    },
    form: {
      title: 'Wie war Dein/e {category}',
      starsLabel: 'Bewerte Dein Erlebnis',
      starsError: 'Bitte gebe Deine Bewertung an',
      textareaLabel: 'Teile Deine Erfahrungen',
      textareaPlaceholder:
        'Wie waren die Verpackung, der Versand und das Erlebnis?',
      textareaText: 'Titel Deiner Bewertung: "{n}..."',
      textareaError: 'Bitte schreibe ein kurzes Feedback.',
      uploadLabel: 'Hier kannst Du Fotos oder Videos hinzufügen',
      uploadText: 'Du kannst maximal {max} Dateien hinzufügen',
      submitButton: 'Bewertung einreichen',
      successTitle: 'Danke für Deine Bewertung!',
      successText: 'Hier ist ein Rabattcode für Dein nächstes Erlebnis:',
      copyCode: 'Rabattcode kopieren',
      copyCodeSuccess: 'Kopiert',
      backButton: 'Zurück zu konfetti',
      selectAnEvent: 'Einen bestimmten Kurs auswählen',
      selectAnotherEvent: 'Einen anderen Kurs wählen',
      eventError: 'Bitte gib einen Kurs an',

      course: {
        title: 'Wie war Dein Kurs?',
        starsLabel: 'Bewerte den Kurs',
        textareaLabel: 'Teile Deine Erfahrungen',
        textareaPlaceholder:
          'Wie waren Kursleiter, die Materialien und Dein Erlebnis? Was hast Du gelernt?',
      },

      tour: {
        title: 'Wie war die Tour?',
        starsLabel: 'Bewerte Deine Tour',
        textareaLabel: 'Teile Deine Erfahrungen',
        textareaPlaceholder:
          'Wie waren die Tourroute, der Guide und Dein Erlebnis insgesamt?',
      },

      experience: {
        title: 'Wie war Dein Erlebnis?',
        starsLabel: 'Bewerte Dein Erlebnis',
        textareaLabel: 'Teile Deine Erfahrungen',
        textareaPlaceholder:
          'Wie waren die Aktivität, die Location und das Personal?',
      },

      kit: {
        title: 'Wie gefällt Dir die DIY-Box?',
        starsLabel: 'Bewerte Deine Box',
        textareaLabel: 'Teile Deine Erfahrungen',
        textareaPlaceholder:
          'Wie sind Inhalt, Verpackung, Versand und das Erlebnis mit der Box?',
      },
    },
    seo: {
      title: 'konfetti - Bewerte Dein Erlebnis',
    },

    transactional: {
      title: 'Kundenbewertungen & Erfahrungen in',
      openEvent: 'Zum Erlebnis',
    },
    anonymous: 'Anonymer Nutzer',
    reviewerImageAlt: 'Foto von {name}',
    reviewerImageAltWithIndex: 'Foto {index} von {name}',
  },
}
